import { useTicketSubmit } from '@/hooks/sales/useTicket';
import { selectActiveTicket, updateTicket } from '@/redux/data/dataSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { SendOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableSelectorModal from './TableSelectorModal';

const SendToKitchenBtn = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const activeTicket = useAppSelector(selectActiveTicket);
  const [showTableSelector, setShowTableSelector] = useState(false);
  const isDineIn = activeTicket?.category === 'IN';
  const hasTable = Boolean(activeTicket?.tableId);

  const { sendToKitchen } = useTicketSubmit();

  const isDisabled = !activeTicket || !activeTicket.items?.length;

  const handleSendToKitchen = () => {
    if (isDineIn && !hasTable) {
      // Show table selector if table not assigned
      setShowTableSelector(true);
      return;
    }
    if (activeTicket?.ID) {
      sendToKitchen(activeTicket.ID);
    }
  };

  const handleTableSelect = (tableId: string) => {
    if (!activeTicket?.ID) return;
    dispatch(
      updateTicket({
        ...activeTicket,
        tableId,
      })
    );
    setShowTableSelector(false);
  };

  return (
    <>
      <Button
        size="large"
        icon={<SendOutlined className="text-xs" />}
        onClick={handleSendToKitchen}
        disabled={isDisabled}
        className="h-12 rounded-lg font-medium text-[10px] lg:text-xs px-4 !bg-orange-500 hover:!bg-orange-600 !border-orange-500 hover:!border-orange-600 !text-white shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out transform hover:scale-[1.02] active:scale-[0.98] disabled:!bg-gray-300 disabled:!border-gray-300 disabled:!opacity-60"
        style={{
          backgroundColor: isDisabled ? '#d1d5db' : '#f97316',
          borderColor: isDisabled ? '#d1d5db' : '#f97316',
          color: '#ffffff',
        }}
        onMouseEnter={(e) => {
          if (!isDisabled) {
            e.currentTarget.style.backgroundColor = '#ea580c';
            e.currentTarget.style.borderColor = '#ea580c';
          }
        }}
        onMouseLeave={(e) => {
          if (!isDisabled) {
            e.currentTarget.style.backgroundColor = '#f97316';
            e.currentTarget.style.borderColor = '#f97316';
          }
        }}
      >
        {t('common:send_to_kitchen')}
      </Button>

      <TableSelectorModal
        open={showTableSelector}
        onSelect={handleTableSelect}
        onCancel={() => setShowTableSelector(false)}
      />
    </>
  );
};

export default SendToKitchenBtn;
